module.exports = __webpack_public_path__ + "images/4e2ac004.img1-chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img1-chs.png
// module id = 383
// module chunks = 0